/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_Contract_NumberInputs */

const cs_contracts_contract_number = /** @type {(inputs: Contracts_Contract_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo smlouvy`)
};

const en_contracts_contract_number = /** @type {(inputs: Contracts_Contract_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract number`)
};

/**
* | output |
* | --- |
* | "Contract number" |
*
* @param {Contracts_Contract_NumberInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_contract_number = /** @type {((inputs?: Contracts_Contract_NumberInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Contract_NumberInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_contract_number(inputs)
	return cs_contracts_contract_number(inputs)
});